<template>
  <v-row class="desposite-dashboadpage keep-safe-dashboard">
    <v-col xs="12" md="12">
      <v-row>
        <v-col xs="8" md="8">
          <ul class="breadcrumbs-list">
            <a @click="backButton"><li>KeepSafe</li></a>
            <li>&nbsp;>&nbsp;Real Estate</li>
            <li>&nbsp;>&nbsp;Real Estate Documents</li>
          </ul>
          <div class="head-text">
            <h1>Real Estate Documents</h1>
          </div>
        </v-col>
        <v-col xs="4" md="4">
          <div class="right-sidetop-box">
            <div class="select-box">
              <v-card>
                <v-select
                  :items="member_items"
                  :v-model="member_name"
                  item-value="id"
                  item-text="name"
                  chips
                  label="All Users"
                  @change="filterData($event, 'member')"
                ></v-select>
              </v-card>
            </div>
          </div>
        </v-col>
      </v-row>
      <template>
        <v-card class="tab-card bg-dot-img">
          <v-tabs v-model="tab">
            <v-tabs-slider></v-tabs-slider>
            <v-tab
              href="#tab-1"
              class="tabs-box"
              @click="updateCurrentTab('tab-1')"
            >
              Title Deed
            </v-tab>
            <v-tab
              href="#tab-2"
              class="tabs-box"
              @click="updateCurrentTab('tab-2')"
            >
              Agreement To Sell
            </v-tab>
            <v-tab
              href="#tab-3"
              class="tabs-box"
              @click="updateCurrentTab('tab-3')"
            >
              No Objection Certificate
            </v-tab>
            <v-tab
              href="#tab-4"
              class="tabs-box"
              @click="updateCurrentTab('tab-4')"
            >
              Title Search & Report
            </v-tab>
            <v-tab
              href="#tab-5"
              class="tabs-box"
              @click="updateCurrentTab('tab-5')"
            >
              Khata Certificate
            </v-tab>
            <v-tab
              href="#tab-6"
              class="tabs-box"
              @click="updateCurrentTab('tab-6')"
            >
              Land Use Certificate
            </v-tab>
            <v-tab
              href="#tab-7"
              class="tabs-box"
              @click="updateCurrentTab('tab-7')"
            >
              Encumbrance Certificate
            </v-tab>
            <v-tab
              href="#tab-8"
              class="tabs-box"
              @click="updateCurrentTab('tab-8')"
            >
              Sanctioned Plan
            </v-tab>
            <v-tab
              href="#tab-9"
              class="tabs-box"
              @click="updateCurrentTab('tab-9')"
            >
              Master Plan
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab" class="tabs-content" xs="8" md="8">
            <!-- title deed list -->
            <v-tab-item value="tab-1">
              <template>
                <v-card class="manage-box">
                  <v-container grid-list-xl class="member-container">
                    <v-layout row wrap v-click-outside="onClickOutside">
                      <v-flex class="cardbox">
                        <v-card
                          elevation="8"
                          v-for="title_deed_list_item in title_deed_list"
                          :key="deposit_certificate_list.entity_id"
                        >
                          <v-container pb-4 grid-list-xl>
                            <v-layout row wrap class="user-detailboxmain">
                              <div class="overline">
                                <v-img
                                  max-height="32"
                                  max-width="40"
                                  :src="
                                    webIcon +
                                    title_deed_list_item.keep_safe_doc_icon
                                  "
                                >
                                </v-img>
                              </div>
                              <v-flex class="user-detailbox">
                                <v-list-item>
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      <p>
                                        {{ title_deed_list_item.property_name }}
                                      </p>
                                      <p>{{ title_deed_list_item.location }}</p>
                                      <p>
                                        {{ title_deed_list_item.property_type }}
                                      </p>
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                                <v-flex class="userdetail">
                                  <v-layout row wrap>
                                    <v-flex md6 sm6 xs12>
                                      <p class="font-weight-medium user-icon">
                                        {{ title_deed_list_item.account_owner }}
                                      </p>
                                    </v-flex>
                                    <v-flex md6 sm6 xs12>
                                      <v-flex
                                        class="upload-img"
                                        v-if="
                                          title_deed_list_item.is_doc_uploaded ==
                                          false
                                        "
                                      >
                                        <v-img
                                          max-height="22"
                                          max-width="18"
                                          :src="
                                            webIcon +
                                            title_deed_list_item.doc_upload_icon
                                          "
                                          @click="
                                            setKeepSafeItemsToStore(
                                              title_deed_list_item
                                            )
                                          "
                                        >
                                        </v-img>
                                      </v-flex>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-flex>
                              <v-col
                                class="memberbox-editbox"
                                v-if="
                                  title_deed_list_item.is_doc_uploaded == true
                                "
                              >
                                <v-menu bottom left offset-y>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      outlined
                                      fab
                                      color="#F19700"
                                      v-bind="attrs"
                                      v-on="on"
                                      @click="
                                        showHide(title_deed_list_item.entity_id)
                                      "
                                    >
                                      <v-img
                                        max-height="20"
                                        max-width="20"
                                        :src="three_dots"
                                        :lazy-src="three_dots"
                                      ></v-img>
                                    </v-btn>
                                  </template>
                                  <v-list
                                    v-if="
                                      title_deed_list_item.entity_id == block_id
                                    "
                                  >
                                    <v-list-item>
                                      <v-list-item-title>
                                        <v-btn
                                          @click="viewDoc(title_deed_list_item)"
                                        >
                                          <v-img
                                            max-height="20"
                                            max-width="20"
                                            :src="view_pic"
                                            :lazy-src="view_pic"
                                          ></v-img>
                                          View
                                        </v-btn>
                                      </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item v-if="allow_user_activity =='yes'">
                                      <v-list-item-title>
                                        <v-btn
                                          @click="
                                            deleteDoc(title_deed_list_item)
                                          "
                                        >
                                          <v-img
                                            max-height="23"
                                            max-width="19"
                                            :src="delete_pic"
                                            :lazy-src="delete_pic"
                                          >
                                          </v-img
                                          >Delete Doc
                                        </v-btn>
                                      </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item v-if="allow_user_activity =='yes'">
                                      <v-list-item-title>
                                        <v-btn
                                          @click="
                                            deleteRecord(title_deed_list_item)
                                          "
                                        >
                                          <v-img
                                            max-height="23"
                                            max-width="19"
                                            :src="delete_pic"
                                            :lazy-src="delete_pic"
                                          >
                                          </v-img
                                          >Delete Record
                                        </v-btn>
                                      </v-list-item-title>
                                    </v-list-item>
                                  </v-list>
                                </v-menu>
                              </v-col>
                            </v-layout>
                          </v-container>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </template>
            </v-tab-item>
            <!-- end of title deed list -->

            <!-- agreement to sell list -->
            <v-tab-item value="tab-2">
              <template>
                <v-card class="manage-box">
                  <v-container grid-list-xl class="member-container">
                    <v-layout row wrap v-click-outside="onClickOutside">
                      <v-flex class="cardbox">
                        <v-card
                          elevation="8"
                          v-for="agreement_to_sell_list_item in agreement_to_sell_list"
                          :key="deposit_certificate_list.entity_id"
                        >
                          <v-container pb-4 grid-list-xl>
                            <v-layout row wrap class="user-detailboxmain">
                              <div class="overline">
                                <v-img
                                  max-height="32"
                                  max-width="40"
                                  :src="
                                    webIcon +
                                    agreement_to_sell_list_item.keep_safe_doc_icon
                                  "
                                >
                                </v-img>
                              </div>
                              <v-flex class="user-detailbox">
                                <v-list-item>
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      <p>
                                        {{
                                          agreement_to_sell_list_item.property_name
                                        }}
                                      </p>
                                      <p>
                                        {{
                                          agreement_to_sell_list_item.location
                                        }}
                                      </p>
                                      <p>
                                        {{
                                          agreement_to_sell_list_item.property_type
                                        }}
                                      </p>
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                                <v-flex class="userdetail">
                                  <v-layout row wrap>
                                    <v-flex md6 sm6 xs12>
                                      <p class="font-weight-medium user-icon">
                                        {{
                                          agreement_to_sell_list_item.account_owner
                                        }}
                                      </p>
                                    </v-flex>
                                    <v-flex md6 sm6 xs12>
                                      <v-flex
                                        class="upload-img"
                                        v-if="
                                          agreement_to_sell_list_item.is_doc_uploaded ==
                                          false
                                        "
                                      >
                                        <v-img
                                          max-height="22"
                                          max-width="18"
                                          :src="
                                            webIcon +
                                            agreement_to_sell_list_item.doc_upload_icon
                                          "
                                          @click="
                                            setKeepSafeItemsToStore(
                                              agreement_to_sell_list_item
                                            )
                                          "
                                        >
                                        </v-img>
                                      </v-flex>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-flex>
                              <v-col
                                class="memberbox-editbox"
                                v-if="
                                  agreement_to_sell_list_item.is_doc_uploaded ==
                                  true
                                "
                              >
                                <v-menu bottom left offset-y>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      outlined
                                      fab
                                      color="#F19700"
                                      v-bind="attrs"
                                      v-on="on"
                                      @click="
                                        showHide(
                                          agreement_to_sell_list_item.entity_id
                                        )
                                      "
                                    >
                                      <v-img
                                        max-height="20"
                                        max-width="20"
                                        :src="three_dots"
                                        :lazy-src="three_dots"
                                      ></v-img>
                                    </v-btn>
                                  </template>
                                  <v-list
                                    v-if="
                                      agreement_to_sell_list_item.entity_id ==
                                      block_id
                                    "
                                  >
                                    <v-list-item>
                                      <v-list-item-title>
                                        <v-btn
                                          @click="
                                            viewDoc(agreement_to_sell_list_item)
                                          "
                                        >
                                          <v-img
                                            max-height="20"
                                            max-width="20"
                                            :src="view_pic"
                                            :lazy-src="view_pic"
                                          ></v-img>
                                          View
                                        </v-btn>
                                      </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item v-if="allow_user_activity =='yes'">
                                      <v-list-item-title>
                                        <v-btn
                                          @click="
                                            deleteDoc(
                                              agreement_to_sell_list_item
                                            )
                                          "
                                        >
                                          <v-img
                                            max-height="23"
                                            max-width="19"
                                            :src="delete_pic"
                                            :lazy-src="delete_pic"
                                          >
                                          </v-img
                                          >Delete Doc
                                        </v-btn>
                                      </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item v-if="allow_user_activity =='yes'">
                                      <v-list-item-title>
                                        <v-btn
                                          @click="
                                            deleteRecord(
                                              agreement_to_sell_list_item
                                            )
                                          "
                                        >
                                          <v-img
                                            max-height="23"
                                            max-width="19"
                                            :src="delete_pic"
                                            :lazy-src="delete_pic"
                                          >
                                          </v-img
                                          >Delete Record
                                        </v-btn>
                                      </v-list-item-title>
                                    </v-list-item>
                                  </v-list>
                                </v-menu>
                              </v-col>
                            </v-layout>
                          </v-container>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </template>
            </v-tab-item>
            <!-- end of agreement to sell list -->

            <!-- no objection certificate list -->
            <v-tab-item value="tab-3">
              <template>
                <v-card class="manage-box">
                  <v-container grid-list-xl class="member-container">
                    <v-layout row wrap v-click-outside="onClickOutside">
                      <v-flex class="cardbox">
                        <v-card
                          elevation="8"
                          v-for="no_objection_certificate_list_item in no_objection_certificate_list"
                          :key="deposit_certificate_list.entity_id"
                        >
                          <v-container pb-4 grid-list-xl>
                            <v-layout row wrap class="user-detailboxmain">
                              <div class="overline">
                                <v-img
                                  max-height="32"
                                  max-width="40"
                                  :src="
                                    webIcon +
                                    no_objection_certificate_list_item.keep_safe_doc_icon
                                  "
                                >
                                </v-img>
                              </div>
                              <v-flex class="user-detailbox">
                                <v-list-item>
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      <p>
                                        {{
                                          no_objection_certificate_list_item.property_name
                                        }}
                                      </p>
                                      <p>
                                        {{
                                          no_objection_certificate_list_item.location
                                        }}
                                      </p>
                                      <p>
                                        {{
                                          no_objection_certificate_list_item.property_type
                                        }}
                                      </p>
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                                <v-flex class="userdetail">
                                  <v-layout row wrap>
                                    <v-flex md6 sm6 xs12>
                                      <p class="font-weight-medium user-icon">
                                        {{
                                          no_objection_certificate_list_item.account_owner
                                        }}
                                      </p>
                                    </v-flex>
                                    <v-flex md6 sm6 xs12>
                                      <v-flex
                                        class="upload-img"
                                        v-if="
                                          no_objection_certificate_list_item.is_doc_uploaded ==
                                          false
                                        "
                                      >
                                        <v-img
                                          max-height="22"
                                          max-width="18"
                                          :src="
                                            webIcon +
                                            no_objection_certificate_list_item.doc_upload_icon
                                          "
                                          @click="
                                            setKeepSafeItemsToStore(
                                              no_objection_certificate_list_item
                                            )
                                          "
                                        >
                                        </v-img>
                                      </v-flex>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-flex>
                              <v-col
                                class="memberbox-editbox"
                                v-if="
                                  no_objection_certificate_list_item.is_doc_uploaded ==
                                  true
                                "
                              >
                                <v-menu bottom left offset-y>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      outlined
                                      fab
                                      color="#F19700"
                                      v-bind="attrs"
                                      v-on="on"
                                      @click="
                                        showHide(
                                          no_objection_certificate_list_item.entity_id
                                        )
                                      "
                                    >
                                      <v-img
                                        max-height="20"
                                        max-width="20"
                                        :src="three_dots"
                                        :lazy-src="three_dots"
                                      ></v-img>
                                    </v-btn>
                                  </template>
                                  <v-list
                                    v-if="
                                      no_objection_certificate_list_item.entity_id ==
                                      block_id
                                    "
                                  >
                                    <v-list-item>
                                      <v-list-item-title>
                                        <v-btn
                                          @click="
                                            viewDoc(
                                              no_objection_certificate_list_item
                                            )
                                          "
                                        >
                                          <v-img
                                            max-height="20"
                                            max-width="20"
                                            :src="view_pic"
                                            :lazy-src="view_pic"
                                          ></v-img>
                                          View
                                        </v-btn>
                                      </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item v-if="allow_user_activity =='yes'">
                                      <v-list-item-title>
                                        <v-btn
                                          @click="
                                            deleteDoc(
                                              no_objection_certificate_list_item
                                            )
                                          "
                                        >
                                          <v-img
                                            max-height="23"
                                            max-width="19"
                                            :src="delete_pic"
                                            :lazy-src="delete_pic"
                                          >
                                          </v-img
                                          >Delete Doc
                                        </v-btn>
                                      </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item v-if="allow_user_activity =='yes'">
                                      <v-list-item-title>
                                        <v-btn
                                          @click="
                                            deleteRecord(
                                              no_objection_certificate_list_item
                                            )
                                          "
                                        >
                                          <v-img
                                            max-height="23"
                                            max-width="19"
                                            :src="delete_pic"
                                            :lazy-src="delete_pic"
                                          >
                                          </v-img
                                          >Delete Record
                                        </v-btn>
                                      </v-list-item-title>
                                    </v-list-item>
                                  </v-list>
                                </v-menu>
                              </v-col>
                            </v-layout>
                          </v-container>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </template>
            </v-tab-item>
            <!-- end of no objection certificate list -->

            <!-- title search report list -->
            <v-tab-item value="tab-4">
              <template>
                <v-card class="manage-box">
                  <v-container grid-list-xl class="member-container">
                    <v-layout row wrap v-click-outside="onClickOutside">
                      <v-flex class="cardbox">
                        <v-card
                          elevation="8"
                          v-for="title_serach_report_list_item in title_serach_report_list"
                          :key="deposit_certificate_list.entity_id"
                        >
                          <v-container pb-4 grid-list-xl>
                            <v-layout row wrap class="user-detailboxmain">
                              <div class="overline">
                                <v-img
                                  max-height="32"
                                  max-width="40"
                                  :src="
                                    webIcon +
                                    title_serach_report_list_item.keep_safe_doc_icon
                                  "
                                >
                                </v-img>
                              </div>
                              <v-flex class="user-detailbox">
                                <v-list-item>
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      <p>
                                        {{
                                          title_serach_report_list_item.property_name
                                        }}
                                      </p>
                                      <p>
                                        {{
                                          title_serach_report_list_item.location
                                        }}
                                      </p>
                                      <p>
                                        {{
                                          title_serach_report_list_item.property_type
                                        }}
                                      </p>
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                                <v-flex class="userdetail">
                                  <v-layout row wrap>
                                    <v-flex md6 sm6 xs12>
                                      <p class="font-weight-medium user-icon">
                                        {{
                                          title_serach_report_list_item.account_owner
                                        }}
                                      </p>
                                    </v-flex>
                                    <v-flex md6 sm6 xs12>
                                      <v-flex
                                        class="upload-img"
                                        v-if="
                                          title_serach_report_list_item.is_doc_uploaded ==
                                          false
                                        "
                                      >
                                        <v-img
                                          max-height="22"
                                          max-width="18"
                                          :src="
                                            webIcon +
                                            title_serach_report_list_item.doc_upload_icon
                                          "
                                          @click="
                                            setKeepSafeItemsToStore(
                                              title_serach_report_list_item
                                            )
                                          "
                                        >
                                        </v-img>
                                      </v-flex>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-flex>
                              <v-col
                                class="memberbox-editbox"
                                v-if="
                                  title_serach_report_list_item.is_doc_uploaded ==
                                  true
                                "
                              >
                                <v-menu bottom left offset-y>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      outlined
                                      fab
                                      color="#F19700"
                                      v-bind="attrs"
                                      v-on="on"
                                      @click="
                                        showHide(
                                          title_serach_report_list_item.entity_id
                                        )
                                      "
                                    >
                                      <v-img
                                        max-height="20"
                                        max-width="20"
                                        :src="three_dots"
                                        :lazy-src="three_dots"
                                      ></v-img>
                                    </v-btn>
                                  </template>
                                  <v-list
                                    v-if="
                                      title_serach_report_list_item.entity_id ==
                                      block_id
                                    "
                                  >
                                    <v-list-item>
                                      <v-list-item-title>
                                        <v-btn
                                          @click="
                                            viewDoc(
                                              title_serach_report_list_item
                                            )
                                          "
                                        >
                                          <v-img
                                            max-height="20"
                                            max-width="20"
                                            :src="view_pic"
                                            :lazy-src="view_pic"
                                          ></v-img>
                                          View
                                        </v-btn>
                                      </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item v-if="allow_user_activity =='yes'">
                                      <v-list-item-title>
                                        <v-btn
                                          @click="
                                            deleteDoc(
                                              title_serach_report_list_item
                                            )
                                          "
                                        >
                                          <v-img
                                            max-height="23"
                                            max-width="19"
                                            :src="delete_pic"
                                            :lazy-src="delete_pic"
                                          >
                                          </v-img
                                          >Delete Doc
                                        </v-btn>
                                      </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item v-if="allow_user_activity =='yes'">
                                      <v-list-item-title>
                                        <v-btn
                                          @click="
                                            deleteRecord(
                                              title_serach_report_list_item
                                            )
                                          "
                                        >
                                          <v-img
                                            max-height="23"
                                            max-width="19"
                                            :src="delete_pic"
                                            :lazy-src="delete_pic"
                                          >
                                          </v-img
                                          >Delete Record
                                        </v-btn>
                                      </v-list-item-title>
                                    </v-list-item>
                                  </v-list>
                                </v-menu>
                              </v-col>
                            </v-layout>
                          </v-container>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </template>
            </v-tab-item>
            <!-- end of title search report list -->

            <!-- khata certificate list -->
            <v-tab-item value="tab-5">
              <template>
                <v-card class="manage-box">
                  <v-container grid-list-xl class="member-container">
                    <v-layout row wrap v-click-outside="onClickOutside">
                      <v-flex class="cardbox">
                        <v-card
                          elevation="8"
                          v-for="khata_certificate_list_item in khata_certificate_list"
                          :key="deposit_certificate_list.entity_id"
                        >
                          <v-container pb-4 grid-list-xl>
                            <v-layout row wrap class="user-detailboxmain">
                              <div class="overline">
                                <v-img
                                  max-height="32"
                                  max-width="40"
                                  :src="
                                    webIcon +
                                    khata_certificate_list_item.keep_safe_doc_icon
                                  "
                                >
                                </v-img>
                              </div>
                              <v-flex class="user-detailbox">
                                <v-list-item>
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      <p>
                                        {{
                                          khata_certificate_list_item.property_name
                                        }}
                                      </p>
                                      <p>
                                        {{
                                          khata_certificate_list_item.location
                                        }}
                                      </p>
                                      <p>
                                        {{
                                          khata_certificate_list_item.property_type
                                        }}
                                      </p>
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                                <v-flex class="userdetail">
                                  <v-layout row wrap>
                                    <v-flex md6 sm6 xs12>
                                      <p class="font-weight-medium user-icon">
                                        {{
                                          khata_certificate_list_item.account_owner
                                        }}
                                      </p>
                                    </v-flex>
                                    <v-flex md6 sm6 xs12>
                                      <v-flex
                                        class="upload-img"
                                        v-if="
                                          khata_certificate_list_item.is_doc_uploaded ==
                                          false
                                        "
                                      >
                                        <v-img
                                          max-height="22"
                                          max-width="18"
                                          :src="
                                            webIcon +
                                            khata_certificate_list_item.doc_upload_icon
                                          "
                                          @click="
                                            setKeepSafeItemsToStore(
                                              khata_certificate_list_item
                                            )
                                          "
                                        >
                                        </v-img>
                                      </v-flex>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-flex>
                              <v-col
                                class="memberbox-editbox"
                                v-if="
                                  khata_certificate_list_item.is_doc_uploaded ==
                                  true
                                "
                              >
                                <v-menu bottom left offset-y>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      outlined
                                      fab
                                      color="#F19700"
                                      v-bind="attrs"
                                      v-on="on"
                                      @click="
                                        showHide(
                                          khata_certificate_list_item.entity_id
                                        )
                                      "
                                    >
                                      <v-img
                                        max-height="20"
                                        max-width="20"
                                        :src="three_dots"
                                        :lazy-src="three_dots"
                                      ></v-img>
                                    </v-btn>
                                  </template>
                                  <v-list
                                    v-if="
                                      khata_certificate_list_item.entity_id ==
                                      block_id
                                    "
                                  >
                                    <v-list-item>
                                      <v-list-item-title>
                                        <v-btn
                                          @click="
                                            viewDoc(khata_certificate_list_item)
                                          "
                                        >
                                          <v-img
                                            max-height="20"
                                            max-width="20"
                                            :src="view_pic"
                                            :lazy-src="view_pic"
                                          ></v-img>
                                          View
                                        </v-btn>
                                      </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item v-if="allow_user_activity =='yes'">
                                      <v-list-item-title>
                                        <v-btn
                                          @click="
                                            deleteDoc(
                                              khata_certificate_list_item
                                            )
                                          "
                                        >
                                          <v-img
                                            max-height="23"
                                            max-width="19"
                                            :src="delete_pic"
                                            :lazy-src="delete_pic"
                                          >
                                          </v-img
                                          >Delete Doc
                                        </v-btn>
                                      </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item v-if="allow_user_activity =='yes'">
                                      <v-list-item-title>
                                        <v-btn
                                          @click="
                                            deleteRecord(
                                              khata_certificate_list_item
                                            )
                                          "
                                        >
                                          <v-img
                                            max-height="23"
                                            max-width="19"
                                            :src="delete_pic"
                                            :lazy-src="delete_pic"
                                          >
                                          </v-img
                                          >Delete Record
                                        </v-btn>
                                      </v-list-item-title>
                                    </v-list-item>
                                  </v-list>
                                </v-menu>
                              </v-col>
                            </v-layout>
                          </v-container>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </template>
            </v-tab-item>
            <!-- end of khata certificate list -->

            <!-- Land use certificate list -->
            <v-tab-item value="tab-6">
              <template>
                <v-card class="manage-box">
                  <v-container grid-list-xl class="member-container">
                    <v-layout row wrap v-click-outside="onClickOutside">
                      <v-flex class="cardbox">
                        <v-card
                          elevation="8"
                          v-for="land_use_certificate_list_item in land_use_certificate_list"
                          :key="deposit_certificate_list.entity_id"
                        >
                          <v-container pb-4 grid-list-xl>
                            <v-layout row wrap class="user-detailboxmain">
                              <div class="overline">
                                <v-img
                                  max-height="32"
                                  max-width="40"
                                  :src="
                                    webIcon +
                                    land_use_certificate_list_item.keep_safe_doc_icon
                                  "
                                >
                                </v-img>
                              </div>
                              <v-flex class="user-detailbox">
                                <v-list-item>
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      <p>
                                        {{
                                          land_use_certificate_list_item.property_name
                                        }}
                                      </p>
                                      <p>
                                        {{
                                          land_use_certificate_list_item.location
                                        }}
                                      </p>
                                      <p>
                                        {{
                                          land_use_certificate_list_item.property_type
                                        }}
                                      </p>
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                                <v-flex class="userdetail">
                                  <v-layout row wrap>
                                    <v-flex md6 sm6 xs12>
                                      <p class="font-weight-medium user-icon">
                                        {{
                                          land_use_certificate_list_item.account_owner
                                        }}
                                      </p>
                                    </v-flex>
                                    <v-flex md6 sm6 xs12>
                                      <v-flex
                                        class="upload-img"
                                        v-if="
                                          land_use_certificate_list_item.is_doc_uploaded ==
                                          false
                                        "
                                      >
                                        <v-img
                                          max-height="22"
                                          max-width="18"
                                          :src="
                                            webIcon +
                                            land_use_certificate_list_item.doc_upload_icon
                                          "
                                          @click="
                                            setKeepSafeItemsToStore(
                                              land_use_certificate_list_item
                                            )
                                          "
                                        >
                                        </v-img>
                                      </v-flex>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-flex>
                              <v-col
                                class="memberbox-editbox"
                                v-if="
                                  land_use_certificate_list_item.is_doc_uploaded ==
                                  true
                                "
                              >
                                <v-menu bottom left offset-y>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      outlined
                                      fab
                                      color="#F19700"
                                      v-bind="attrs"
                                      v-on="on"
                                      @click="
                                        showHide(
                                          land_use_certificate_list_item.entity_id
                                        )
                                      "
                                    >
                                      <v-img
                                        max-height="20"
                                        max-width="20"
                                        :src="three_dots"
                                        :lazy-src="three_dots"
                                      ></v-img>
                                    </v-btn>
                                  </template>
                                  <v-list
                                    v-if="
                                      land_use_certificate_list_item.entity_id ==
                                      block_id
                                    "
                                  >
                                    <v-list-item>
                                      <v-list-item-title>
                                        <v-btn
                                          @click="
                                            viewDoc(
                                              land_use_certificate_list_item
                                            )
                                          "
                                        >
                                          <v-img
                                            max-height="20"
                                            max-width="20"
                                            :src="view_pic"
                                            :lazy-src="view_pic"
                                          ></v-img>
                                          View
                                        </v-btn>
                                      </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item v-if="allow_user_activity =='yes'">
                                      <v-list-item-title>
                                        <v-btn
                                          @click="
                                            deleteDoc(
                                              land_use_certificate_list_item
                                            )
                                          "
                                        >
                                          <v-img
                                            max-height="23"
                                            max-width="19"
                                            :src="delete_pic"
                                            :lazy-src="delete_pic"
                                          >
                                          </v-img
                                          >Delete Doc
                                        </v-btn>
                                      </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item v-if="allow_user_activity =='yes'">
                                      <v-list-item-title>
                                        <v-btn
                                          @click="
                                            deleteRecord(
                                              land_use_certificate_list_item
                                            )
                                          "
                                        >
                                          <v-img
                                            max-height="23"
                                            max-width="19"
                                            :src="delete_pic"
                                            :lazy-src="delete_pic"
                                          >
                                          </v-img
                                          >Delete Record
                                        </v-btn>
                                      </v-list-item-title>
                                    </v-list-item>
                                  </v-list>
                                </v-menu>
                              </v-col>
                            </v-layout>
                          </v-container>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </template>
            </v-tab-item>
            <!-- end of Land use certificate list -->

            <!-- encumbrance certificate list -->
            <v-tab-item value="tab-7">
              <template>
                <v-card class="manage-box">
                  <v-container grid-list-xl class="member-container">
                    <v-layout row wrap v-click-outside="onClickOutside">
                      <v-flex class="cardbox">
                        <v-card
                          elevation="8"
                          v-for="encumbrance_certificate_list_item in encumbrance_certificate_list"
                          :key="deposit_certificate_list.entity_id"
                        >
                          <v-container pb-4 grid-list-xl>
                            <v-layout row wrap class="user-detailboxmain">
                              <div class="overline">
                                <v-img
                                  max-height="32"
                                  max-width="40"
                                  :src="
                                    webIcon +
                                    encumbrance_certificate_list_item.keep_safe_doc_icon
                                  "
                                >
                                </v-img>
                              </div>
                              <v-flex class="user-detailbox">
                                <v-list-item>
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      <p>
                                        {{
                                          encumbrance_certificate_list_item.property_name
                                        }}
                                      </p>
                                      <p>
                                        {{
                                          encumbrance_certificate_list_item.location
                                        }}
                                      </p>
                                      <p>
                                        {{
                                          encumbrance_certificate_list_item.property_type
                                        }}
                                      </p>
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                                <v-flex class="userdetail">
                                  <v-layout row wrap>
                                    <v-flex md6 sm6 xs12>
                                      <p class="font-weight-medium user-icon">
                                        {{
                                          encumbrance_certificate_list_item.account_owner
                                        }}
                                      </p>
                                    </v-flex>
                                    <v-flex md6 sm6 xs12>
                                      <v-flex
                                        class="upload-img"
                                        v-if="
                                          encumbrance_certificate_list_item.is_doc_uploaded ==
                                          false
                                        "
                                      >
                                        <v-img
                                          max-height="22"
                                          max-width="18"
                                          :src="
                                            webIcon +
                                            encumbrance_certificate_list_item.doc_upload_icon
                                          "
                                          @click="
                                            setKeepSafeItemsToStore(
                                              encumbrance_certificate_list_item
                                            )
                                          "
                                        >
                                        </v-img>
                                      </v-flex>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-flex>
                              <v-col
                                class="memberbox-editbox"
                                v-if="
                                  encumbrance_certificate_list_item.is_doc_uploaded ==
                                  true
                                "
                              >
                                <v-menu bottom left offset-y>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      outlined
                                      fab
                                      color="#F19700"
                                      v-bind="attrs"
                                      v-on="on"
                                      @click="
                                        showHide(
                                          encumbrance_certificate_list_item.entity_id
                                        )
                                      "
                                    >
                                      <v-img
                                        max-height="20"
                                        max-width="20"
                                        :src="three_dots"
                                        :lazy-src="three_dots"
                                      ></v-img>
                                    </v-btn>
                                  </template>
                                  <v-list
                                    v-if="
                                      encumbrance_certificate_list_item.entity_id ==
                                      block_id
                                    "
                                  >
                                    <v-list-item>
                                      <v-list-item-title>
                                        <v-btn
                                          @click="
                                            viewDoc(
                                              encumbrance_certificate_list_item
                                            )
                                          "
                                        >
                                          <v-img
                                            max-height="20"
                                            max-width="20"
                                            :src="view_pic"
                                            :lazy-src="view_pic"
                                          ></v-img>
                                          View
                                        </v-btn>
                                      </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item v-if="allow_user_activity =='yes'">
                                      <v-list-item-title>
                                        <v-btn
                                          @click="
                                            deleteDoc(
                                              encumbrance_certificate_list_item
                                            )
                                          "
                                        >
                                          <v-img
                                            max-height="23"
                                            max-width="19"
                                            :src="delete_pic"
                                            :lazy-src="delete_pic"
                                          >
                                          </v-img
                                          >Delete Doc
                                        </v-btn>
                                      </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item v-if="allow_user_activity =='yes'">
                                      <v-list-item-title>
                                        <v-btn
                                          @click="
                                            deleteRecord(
                                              encumbrance_certificate_list_item
                                            )
                                          "
                                        >
                                          <v-img
                                            max-height="23"
                                            max-width="19"
                                            :src="delete_pic"
                                            :lazy-src="delete_pic"
                                          >
                                          </v-img
                                          >Delete Record
                                        </v-btn>
                                      </v-list-item-title>
                                    </v-list-item>
                                  </v-list>
                                </v-menu>
                              </v-col>
                            </v-layout>
                          </v-container>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </template>
            </v-tab-item>
            <!-- end of encumbrance certificate list -->

            <!-- sanctioned plan certificate list -->
            <v-tab-item value="tab-8">
              <template>
                <v-card class="manage-box">
                  <v-container grid-list-xl class="member-container">
                    <v-layout row wrap v-click-outside="onClickOutside">
                      <v-flex class="cardbox">
                        <v-card
                          elevation="8"
                          v-for="sanctioned_plan_list_item in sanctioned_plan_list"
                          :key="deposit_certificate_list.entity_id"
                        >
                          <v-container pb-4 grid-list-xl>
                            <v-layout row wrap class="user-detailboxmain">
                              <div class="overline">
                                <v-img
                                  max-height="32"
                                  max-width="40"
                                  :src="
                                    webIcon +
                                    sanctioned_plan_list_item.keep_safe_doc_icon
                                  "
                                >
                                </v-img>
                              </div>
                              <v-flex class="user-detailbox">
                                <v-list-item>
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      <p>
                                        {{
                                          sanctioned_plan_list_item.property_name
                                        }}
                                      </p>
                                      <p>
                                        {{ sanctioned_plan_list_item.location }}
                                      </p>
                                      <p>
                                        {{
                                          sanctioned_plan_list_item.property_type
                                        }}
                                      </p>
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                                <v-flex class="userdetail">
                                  <v-layout row wrap>
                                    <v-flex md6 sm6 xs12>
                                      <p class="font-weight-medium user-icon">
                                        {{
                                          sanctioned_plan_list_item.account_owner
                                        }}
                                      </p>
                                    </v-flex>
                                    <v-flex md6 sm6 xs12>
                                      <v-flex
                                        class="upload-img"
                                        v-if="
                                          sanctioned_plan_list_item.is_doc_uploaded ==
                                          false
                                        "
                                      >
                                        <v-img
                                          max-height="22"
                                          max-width="18"
                                          :src="
                                            webIcon +
                                            sanctioned_plan_list_item.doc_upload_icon
                                          "
                                          @click="
                                            setKeepSafeItemsToStore(
                                              sanctioned_plan_list_item
                                            )
                                          "
                                        >
                                        </v-img>
                                      </v-flex>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-flex>
                              <v-col
                                class="memberbox-editbox"
                                v-if="
                                  sanctioned_plan_list_item.is_doc_uploaded ==
                                  true
                                "
                              >
                                <v-menu bottom left offset-y>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      outlined
                                      fab
                                      color="#F19700"
                                      v-bind="attrs"
                                      v-on="on"
                                      @click="
                                        showHide(
                                          sanctioned_plan_list_item.entity_id
                                        )
                                      "
                                    >
                                      <v-img
                                        max-height="20"
                                        max-width="20"
                                        :src="three_dots"
                                        :lazy-src="three_dots"
                                      ></v-img>
                                    </v-btn>
                                  </template>
                                  <v-list
                                    v-if="
                                      sanctioned_plan_list_item.entity_id ==
                                      block_id
                                    "
                                  >
                                    <v-list-item>
                                      <v-list-item-title>
                                        <v-btn
                                          @click="
                                            viewDoc(sanctioned_plan_list_item)
                                          "
                                        >
                                          <v-img
                                            max-height="20"
                                            max-width="20"
                                            :src="view_pic"
                                            :lazy-src="view_pic"
                                          ></v-img>
                                          View
                                        </v-btn>
                                      </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item v-if="allow_user_activity =='yes'">
                                      <v-list-item-title>
                                        <v-btn
                                          @click="
                                            deleteDoc(sanctioned_plan_list_item)
                                          "
                                        >
                                          <v-img
                                            max-height="23"
                                            max-width="19"
                                            :src="delete_pic"
                                            :lazy-src="delete_pic"
                                          >
                                          </v-img
                                          >Delete Doc
                                        </v-btn>
                                      </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item v-if="allow_user_activity =='yes'">
                                      <v-list-item-title>
                                        <v-btn
                                          @click="
                                            deleteRecord(
                                              sanctioned_plan_list_item
                                            )
                                          "
                                        >
                                          <v-img
                                            max-height="23"
                                            max-width="19"
                                            :src="delete_pic"
                                            :lazy-src="delete_pic"
                                          >
                                          </v-img
                                          >Delete Record
                                        </v-btn>
                                      </v-list-item-title>
                                    </v-list-item>
                                  </v-list>
                                </v-menu>
                              </v-col>
                            </v-layout>
                          </v-container>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </template>
            </v-tab-item>
            <!-- end of sanctioned plan certificate list -->

            <!-- master plan certificate list -->
            <v-tab-item value="tab-9">
              <template>
                <v-card class="manage-box">
                  <v-container grid-list-xl class="member-container">
                    <v-layout row wrap v-click-outside="onClickOutside">
                      <v-flex class="cardbox">
                        <v-card
                          elevation="8"
                          v-for="master_plan_list_item in master_plan_list"
                          :key="deposit_certificate_list.entity_id"
                        >
                          <v-container pb-4 grid-list-xl>
                            <v-layout row wrap class="user-detailboxmain">
                              <div class="overline">
                                <v-img
                                  max-height="32"
                                  max-width="40"
                                  :src="
                                    webIcon +
                                    master_plan_list_item.keep_safe_doc_icon
                                  "
                                >
                                </v-img>
                              </div>
                              <v-flex class="user-detailbox">
                                <v-list-item>
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      <p>
                                        {{
                                          master_plan_list_item.property_name
                                        }}
                                      </p>
                                      <p>
                                        {{ master_plan_list_item.location }}
                                      </p>
                                      <p>
                                        {{
                                          master_plan_list_item.property_type
                                        }}
                                      </p>
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                                <v-flex class="userdetail">
                                  <v-layout row wrap>
                                    <v-flex md6 sm6 xs12>
                                      <p class="font-weight-medium user-icon">
                                        {{
                                          master_plan_list_item.account_owner
                                        }}
                                      </p>
                                    </v-flex>
                                    <v-flex md6 sm6 xs12>
                                      <v-flex
                                        class="upload-img"
                                        v-if="
                                          master_plan_list_item.is_doc_uploaded ==
                                          false
                                        "
                                      >
                                        <v-img
                                          max-height="22"
                                          max-width="18"
                                          :src="
                                            webIcon +
                                            master_plan_list_item.doc_upload_icon
                                          "
                                          @click="
                                            setKeepSafeItemsToStore(
                                              master_plan_list_item
                                            )
                                          "
                                        >
                                        </v-img>
                                      </v-flex>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-flex>
                              <v-col
                                class="memberbox-editbox"
                                v-if="
                                  master_plan_list_item.is_doc_uploaded == true
                                "
                              >
                                <v-menu bottom left offset-y>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      outlined
                                      fab
                                      color="#F19700"
                                      v-bind="attrs"
                                      v-on="on"
                                      @click="
                                        showHide(
                                          master_plan_list_item.entity_id
                                        )
                                      "
                                    >
                                      <v-img
                                        max-height="20"
                                        max-width="20"
                                        :src="three_dots"
                                        :lazy-src="three_dots"
                                      ></v-img>
                                    </v-btn>
                                  </template>
                                  <v-list
                                    v-if="
                                      master_plan_list_item.entity_id ==
                                      block_id
                                    "
                                  >
                                    <v-list-item>
                                      <v-list-item-title>
                                        <v-btn
                                          @click="
                                            viewDoc(master_plan_list_item)
                                          "
                                        >
                                          <v-img
                                            max-height="20"
                                            max-width="20"
                                            :src="view_pic"
                                            :lazy-src="view_pic"
                                          ></v-img>
                                          View
                                        </v-btn>
                                      </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item v-if="allow_user_activity =='yes'">
                                      <v-list-item-title>
                                        <v-btn
                                          @click="
                                            deleteDoc(master_plan_list_item)
                                          "
                                        >
                                          <v-img
                                            max-height="23"
                                            max-width="19"
                                            :src="delete_pic"
                                            :lazy-src="delete_pic"
                                          >
                                          </v-img
                                          >Delete Doc
                                        </v-btn>
                                      </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item v-if="allow_user_activity =='yes'">
                                      <v-list-item-title>
                                        <v-btn
                                          @click="
                                            deleteRecord(master_plan_list_item)
                                          "
                                        >
                                          <v-img
                                            max-height="23"
                                            max-width="19"
                                            :src="delete_pic"
                                            :lazy-src="delete_pic"
                                          >
                                          </v-img
                                          >Delete Record
                                        </v-btn>
                                      </v-list-item-title>
                                    </v-list-item>
                                  </v-list>
                                </v-menu>
                              </v-col>
                            </v-layout>
                          </v-container>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </template>
            </v-tab-item>
            <!-- end of master plan certificate list -->
          </v-tabs-items>
        </v-card>
      </template>
    </v-col>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Upload Doc</span>
        </v-card-title>
        <form
          ref="form"
          id="upload_deposit_keep_safe_form"
          @submit.prevent
          lazy-validation
        >
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-file-input
                    name="file"
                    id="fileUpload"
                    ref="file"
                    @change="handleFileUpload($event)"
                    label="Choose Doc"
                    accept=".pdf"
                    :key="componentKey"
                  ></v-file-input>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDialog()">
              Close
            </v-btn>
            <v-btn color="blue darken-1" text @click="submit"> Upload </v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { Auth } from "aws-amplify";
import {
  GET_LAST_CHOOSEN_KEEP_SAFE_FORM_DATA,
  GET_REAL_ESTATE_KEEP_SAFE_DATA,
} from "../../store/actions.type";
import axios from "axios";
import { isEmpty } from "lodash";
import JwtService from ".././common/jwt.service";
export default {
  data: () => ({
    category: "",
    webIcon: process.env.VUE_APP_ROOT_ICONS_URL,
    subcategory_items_list: [],
    response_data: "",
    tab: "",
    three_dots: process.env.VUE_APP_ROOT_ICONS_URL + "three_dots.png",
    edit_pic: process.env.VUE_APP_ROOT_ICONS_URL + "edit.png",
    delete_pic: process.env.VUE_APP_ROOT_ICONS_URL + "delete.png",
    view_pic: process.env.VUE_APP_ROOT_ICONS_URL + "view.png",
    result: "",
    deposit_certificate_list: [],
    tds_certificate_list: [],
    member_items: [],
    member_name: "",
    block_id: "",
    is_active_block_display: true,
    dialog: false,
    file: "",
    list: {},
    recent_upload_entry_detail: {},
    full_name: "",
    filtered_list: [],
    current_tab: "tab-1",
    current_filtered_member: "",
    current_filtered_year: "2022-2023",
    year_items: {},
    financial_year_month: "",
    entity_id: "",
    title_deed_list: "",
    agreement_to_sell_list: "",
    no_objection_certificate_list: "",
    title_serach_report_list: "",
    khata_certificate_list: "",
    land_use_certificate_list: "",
    encumbrance_certificate_list: "",
    sanctioned_plan_list: "",
    master_plan_list: "",
    componentKey: 0,
    allow_user_activity:localStorage.getItem('allow_user_activity')
  }),
  mounted() {
    console.log(
      this.$store.getters.getRealEstateKeepSafeDetail.data.title_deed
    );
    if (
      isEmpty(
        this.$store.getters.getRealEstateKeepSafeDetail.data.title_deed
      ) ||
      this.$store.getters.getRealEstateKeepSafeDetail.data.title_deed ==
        "undefined"
    ) {
      this.fetchKeepSafeDetail();
    } else {
      this.appendTitleDeedList();
      this.appendMemberList();
    }
  },
  created() {
    this.fetchKeepSafeDetail();
  },
  methods: {
    updateCurrentTab(current_tab) {
      this.current_tab = current_tab;
      if (current_tab == "tab-1") {
        this.appendTitleDeedList();
      }
      if (current_tab == "tab-2") {
        this.appendAgreementToSellList();
      } else if (current_tab == "tab-3") {
        this.appendNoObjectionCertificateList();
      } else if (current_tab == "tab-4") {
        this.appendTitleSerachReportList();
      } else if (current_tab == "tab-5") {
        this.appendKhataCertificateList();
      } else if (current_tab == "tab-6") {
        this.appendLandUseCertificateList();
      } else if (current_tab == "tab-7") {
        this.appendEncumbranceCertificateList();
      } else if (current_tab == "tab-8") {
        this.appendSanctionedPlanList();
      } else if (current_tab == "tab-9") {
        this.appendMasterPlanList();
      }
    },

    appendMasterPlanList() {
      this.master_plan_list = [];
      this.result = this.$store.getters.getRealEstateKeepSafeDetail;
      if (this.current_filtered_member != "") {
        this.result.data.master_plan.forEach((elementData) => {
          if (elementData.member_id == this.current_filtered_member) {
            this.master_plan_list.push(elementData);
          }
        });
      } else {
        this.master_plan_list = this.result.data.master_plan;
      }
    },

    appendSanctionedPlanList() {
      this.sanctioned_plan_list = [];
      this.result = this.$store.getters.getRealEstateKeepSafeDetail;
      if (this.current_filtered_member != "") {
        this.result.data.sanctioned_plan.forEach((elementData) => {
          if (elementData.member_id == this.current_filtered_member) {
            this.sanctioned_plan_list.push(elementData);
          }
        });
      } else {
        this.sanctioned_plan_list = this.result.data.sanctioned_plan;
      }
    },

    appendEncumbranceCertificateList() {
      this.encumbrance_certificate_list = [];
      this.result = this.$store.getters.getRealEstateKeepSafeDetail;
      if (this.current_filtered_member != "") {
        this.result.data.encumbrance_certificate.forEach((elementData) => {
          if (elementData.member_id == this.current_filtered_member) {
            this.encumbrance_certificate_list.push(elementData);
          }
        });
      } else {
        this.encumbrance_certificate_list =
          this.result.data.encumbrance_certificate;
      }
    },

    appendLandUseCertificateList() {
      this.land_use_certificate_list = [];
      this.result = this.$store.getters.getRealEstateKeepSafeDetail;
      if (this.current_filtered_member != "") {
        this.result.data.land_use_cretificate.forEach((elementData) => {
          if (elementData.member_id == this.current_filtered_member) {
            this.land_use_certificate_list.push(elementData);
          }
        });
      } else {
        this.land_use_certificate_list = this.result.data.land_use_cretificate;
      }
    },

    appendKhataCertificateList() {
      this.khata_certificate_list = [];
      this.result = this.$store.getters.getRealEstateKeepSafeDetail;
      if (this.current_filtered_member != "") {
        this.result.data.khata_certificate.forEach((elementData) => {
          if (elementData.member_id == this.current_filtered_member) {
            this.khata_certificate_list.push(elementData);
          }
        });
      } else {
        this.khata_certificate_list = this.result.data.khata_certificate;
      }
    },

    appendTitleSerachReportList() {
      this.title_serach_report_list = [];
      this.result = this.$store.getters.getRealEstateKeepSafeDetail;
      if (this.current_filtered_member != "") {
        this.result.data.title_search_report.forEach((elementData) => {
          if (elementData.member_id == this.current_filtered_member) {
            this.title_serach_report_list.push(elementData);
          }
        });
      } else {
        this.title_serach_report_list = this.result.data.title_search_report;
      }
    },

    appendNoObjectionCertificateList() {
      this.no_objection_certificate_list = [];
      this.result = this.$store.getters.getRealEstateKeepSafeDetail;
      if (this.current_filtered_member != "") {
        this.result.data.no_objection_certificate.forEach((elementData) => {
          if (elementData.member_id == this.current_filtered_member) {
            this.no_objection_certificate_list.push(elementData);
          }
        });
      } else {
        this.no_objection_certificate_list =
          this.result.data.no_objection_certificate;
      }
    },

    appendAgreementToSellList() {
      this.agreement_to_sell_list = [];
      this.result = this.$store.getters.getRealEstateKeepSafeDetail;
      if (this.current_filtered_member != "") {
        this.result.data.agreement_to_sell.forEach((elementData) => {
          if (elementData.member_id == this.current_filtered_member) {
            this.agreement_to_sell_list.push(elementData);
          }
        });
      } else {
        this.agreement_to_sell_list = this.result.data.agreement_to_sell;
      }
    },

    appendTitleDeedList() {
      this.title_deed_list = [];
      this.result = this.$store.getters.getRealEstateKeepSafeDetail;
      if (this.current_filtered_member != "") {
        this.result.data.title_deed.forEach((elementData) => {
          if (elementData.member_id == this.current_filtered_member) {
            this.title_deed_list.push(elementData);
          }
        });
      } else {
        this.title_deed_list = this.result.data.title_deed;
      }
    },

    fetchKeepSafeDetail() {
      Auth.currentAuthenticatedUser({
        bypassCache: true,
      })
        .then((user) => {
          this.$store
            .dispatch(GET_REAL_ESTATE_KEEP_SAFE_DATA, {
              data: {
                aws_cognito_id: atob(localStorage.getItem("cognito_idp")),
                user_name: user.attributes["custom:name"],
                module_type: "real_estate",
              },
              api: "get-real-estate-keeps-afe-detail",
            })
            .then(() => {
              this.appendTitleDeedList();
              this.appendAgreementToSellList();
              this.appendMemberList();
              this.appendNoObjectionCertificateList();
              this.appendTitleSerachReportList();
              this.appendKhataCertificateList();
              this.appendLandUseCertificateList();
              this.appendEncumbranceCertificateList();
              this.appendSanctionedPlanList();
              this.appendMasterPlanList();
            });
        })
        .catch((err) => {});
    },

    appendMemberList() {
      this.member_items = [];
      this.result = this.$store.getters.getRealEstateKeepSafeDetail;
      this.result.member_list.forEach((elementData) => {
        this.member_items.push({ id: elementData.id, name: elementData.name });
      });
    },

    backButton() {
      this.$router.push({ name: "KeepSafeCategory" }).catch(() => {});
    },

    onClickOutside() {
      this.active = false;
    },

    showHide(entity_id) {
      this.block_id = entity_id;
      // if (this.block_id != "" && this.block_id == entity_id) {
      //   this.block_id = "";
      //   this.is_active_block_display = false;
      // } else if (this.block_id != "" && this.block_id != entity_id) {
      //   this.block_id = "";
      //   this.block_id = entity_id;
      // } else {
      //   this.block_id = entity_id;
      //   this.is_active_block_display = true;
      // }
    },

    setKeepSafeItemsToStore(form_items) {
      this.$store.dispatch(GET_LAST_CHOOSEN_KEEP_SAFE_FORM_DATA, form_items);
      this.dialog = true;
    },

    handleFileUpload() {
      this.file = document.getElementById("fileUpload").files[0];
      if (this.file.type != "application/pdf") {
        swal.fire({
          title: "Invalid File",
          text: "Only pdf file is allowed.",
          icon: "error",
          showCancelButton: false,
          confirmButtonColor: "#051d42",
          confirmButtonText: "OK",
        });
        this.componentKey++;
        this.file = "";
      }
    },

    submit(e) {
      this.submitted = true;
      let cognito_idp = atob(localStorage.getItem("cognito_idp"));
      this.recent_upload_entry_detail =
        this.$store.getters.getLastChoosenKeepSafeFormDetail;
      let formdata = new FormData();
      formdata.append("aws_cognito_id", cognito_idp);

      formdata.append(
        "module_type",
        this.recent_upload_entry_detail.module_type
      );
      formdata.append("type", this.recent_upload_entry_detail.type);
      formdata.append("member_id", this.recent_upload_entry_detail.member_id);
      formdata.append(
        "financial_year",
        this.recent_upload_entry_detail.financial_year
      );
      formdata.append("entity_id", this.recent_upload_entry_detail.entity_id);
      formdata.append("doc_file", this.file);

      axios
        .post(
          process.env.VUE_APP_ROOT_API + "upload-real-estate-keep-safe-data",
          formdata,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then(() => {
          this.$refs.file.value=null
          this.$refs.file.reset()
          this.fetchKeepSafeDetail();
          this.dialog = false;
          Toast.fire({
            icon: "success",
            title: "Doc uploaded successfully",
          });
        })
        .catch(() => {
          this.$loading(false);
        });
    },
    viewDoc(item){
      let formdata    = new FormData();
      formdata.append("aws_cognito_id", atob(localStorage.getItem('cognito_idp')));
      formdata.append("entity_id", item.entity_id);
      axios.post( process.env.VUE_APP_ROOT_API+'get-presigned-url', formdata).then((response) => {
        window.open(response.data.url,  '_blank');
      }).catch(() => { });
    },
    deleteDoc(item) {
      swal
        .fire({
          title: "Are you sure, you want to delete this doc?",
          showCancelButton: true,
          confirmButtonColor: `#051d42`,
          confirmButtonText: `YES`,
          cancelButtonColor: `#f19700`,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.$store
              .dispatch(GET_REAL_ESTATE_KEEP_SAFE_DATA, {
                data: {
                  aws_cognito_id: atob(localStorage.getItem("cognito_idp")),
                  entity_id: item.entity_id,
                  module_type: item.module_type,
                  type: item.type,
                  member_id: item.member_id,
                  financial_year: item.financial_year,
                  financial_year_month: item.month_name,
                },
                api: "delete-deposit-keep-safe-detail",
              })
              .then(() => {
                this.fetchKeepSafeDetail();
                this.dialog = false;
                Toast.fire({
                  icon: "success",
                  title: "Doc deleted successfully",
                });
              });
          } else if (result.isDenied) {
            Swal.fire("Changes are not saved", "", "info");
          }
        });
    },

    deleteRecord(item) {
      swal
        .fire({
          title: "Are you sure, you want to delete this record?",
          showCancelButton: true,
          confirmButtonColor: `#051d42`,
          confirmButtonText: `YES`,
          cancelButtonColor: `#f19700`,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.$store
              .dispatch(
                GET_MUTUAL_FUND_KEEP_SAFE_DATAGET_REAL_ESTATE_KEEP_SAFE_DATA,
                {
                  data: {
                    aws_cognito_id: atob(localStorage.getItem("cognito_idp")),
                    entity_id: item.entity_id,
                  },
                  api: "remove-user-form-entry",
                }
              )
              .then(() => {
                this.fetchKeepSafeDetail();
                this.dialog = false;
                Toast.fire({
                  icon: "success",
                  title: "Record deleted successfully",
                });
              });
          } else if (result.isDenied) {
            Swal.fire("Changes are not saved", "", "info");
          }
        });
    },

    filterData(event, type) {
      if (type == "member") {
        this.current_filtered_member = event.toString();
      } else if (type == "year") {
        this.current_filtered_year = event.toString();
      }
      if (this.current_tab == "tab-1") {
        this.appendTitleDeedList();
      } else if (this.current_tab == "tab-2") {
        this.appendAgreementToSellList();
      } else if (this.current_tab == "tab-3") {
        this.appendNoObjectionCertificateList();
      } else if (this.current_tab == "tab-4") {
        this.appendTitleSerachReportList();
      } else if (this.current_tab == "tab-5") {
        this.appendKhataCertificateList();
      } else if (this.current_tab == "tab-6") {
        this.appendLandUseCertificateList();
      } else if (this.current_tab == "tab-7") {
        this.appendEncumbranceCertificateList();
      } else if (this.current_tab == "tab-8") {
        this.appendSanctionedPlanList();
      } else if (this.current_tab == "tab-9") {
        this.appendMasterPlanList();
      }
    },

    closeDialog(){
      this.$refs.file.value=null
      this.$refs.file.reset()
      this.dialog = false
    }
  },
};
</script>